import {BasicButton} from '@packages/ui';
import Image from 'next/image';
import {CommonLink} from '../../../../../shared/components/CommonLink';
import {getMailAuthLinkWithParamsHooks} from '../../../../../shared/services/getMailAuthLinkWithParamsHooks';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';

type StaticCompany = {
  id: number;
  companyName: string;
};

type TopCompany = {
  id: number;
  name: string;
  logo_url: string;
  background_image_url: string;
  catch_phrase: string;
};

type CompanyListForNoLoggedInProps = {
  staticCompanies: StaticCompany[];
  topCompanies?: {
    companies: TopCompany[];
  };
};

export const CompanyListForNoLoggedIn: React.FC<
  CompanyListForNoLoggedInProps
> = ({staticCompanies, topCompanies}) => {
  const {isPC} = useMediaQuery();
  const allCompanies = topCompanies?.companies || [];
  const mailAuthLink = getMailAuthLinkWithParamsHooks({});

  return (
    <div className="bg-white mt-12 py-12 pt-32 px-24 pc:w-[1200px]">
      <div className="font-bold text-lg">企業を探す</div>
      <div className="text-sm text-black-2 mt-8">
        トップ企業の本選考・インターン・説明会やセミナーなどの新着情報をまとめてGETできます。
      </div>
      <div className="justify-around my-24 flex-wrap flex">
        {isPC
          ? allCompanies.slice(0, 9).map((company, index) => {
              return (
                <div key={`company-${index}`} className="mt-4 max-w-[100px]">
                  <CommonLink
                    href={`/company/${company.id}`}
                    className="hover:underline"
                  >
                    <Image
                      src={company.logo_url}
                      alt={company.name}
                      width={100}
                      height={75}
                      className="object-contain block w-[60px] h-[45px] pc:w-[100px] pc:h-[75px] border border-solid"
                    />
                    {isPC && (
                      <span className="ml-4 text-xs text-link-1">
                        {company.name}
                      </span>
                    )}
                  </CommonLink>
                </div>
              );
            })
          : allCompanies.map((company, index) => {
              return (
                <div key={`company-${index}`} className="mt-4">
                  <CommonLink href={`/company/${company.id}`}>
                    <Image
                      src={company.logo_url}
                      alt={company.name}
                      width={100}
                      height={75}
                      className="object-contain block w-[60px] h-[45px] pc:w-[100px] pc:h-[75px] border border-solid"
                    />
                    {isPC && (
                      <span className="ml-4 text-xs text-link-1">
                        {company.name}
                      </span>
                    )}
                  </CommonLink>
                </div>
              );
            })}
      </div>
      <div className="hidden pc:block bg-black-5 p-12 mb-8">
        <div className="text-black-2">〈掲載企業の例〉</div>
        <div className="flex flex-wrap">
          {staticCompanies.map((company, index) => {
            return (
              <div key={`company-${index}`} className="mt-4 mr-16">
                <CommonLink
                  href={`/company/${company.id}`}
                  className="hover:underline"
                >
                  <span className="text-sm text-link-1 whitespace-nowrap">
                    {company.companyName}
                  </span>
                </CommonLink>
              </div>
            );
          })}
        </div>
      </div>
      <div className="pb-12 hidden pc:block">
        {/* 会員登録ボタン */}
        <BasicButton
          label="無料会員登録してもっと見る"
          isPrimary={true}
          isLarge={true}
          onClick={() => {
            location.href = mailAuthLink;
          }}
          className="w-full"
        />
      </div>
    </div>
  );
};
